<template>
  <v-dialog v-model="showDialog" persistent max-width="500px">
    <v-card class="py-2 px-4">
      <i
          id="closeButton"
          class="far fa-times"
          @click="showDialog = false"
      ></i>
      <v-card-title class="headline mb-2 px-2 pt-1">
        Upload File
      </v-card-title>
      <div
        class="kt-grid kt-wizard-v1 kt-wizard-v1--white"
      >
        <div class="kt-grid__item">
          <div class="kt-wizard-v1__nav">
            <div class="kt-wizard-v1__nav-items">
              <a
                  class="kt-wizard-v1__nav-item"
                  href="javascript:"
                  :class="currentStep === 1 ? 'current-step' : ''"
              >
                <div class="kt-wizard-v1__nav-body">
                  <div class="kt-wizard-v1__nav-icon">
                    <i class="fa fa-file-import"></i>
                  </div>
                  <div class="kt-wizard-v1__nav-label">Upload File</div>
                </div>
              </a>
              <a
                  class="kt-wizard-v1__nav-item"
                  href="javascript:"
                  :class="currentStep === 2 ? 'current-step' : ''"
              >
                <div class="kt-wizard-v1__nav-body">
                  <div class="kt-wizard-v1__nav-icon">
                    <i class="fa fa-tasks"></i>
                  </div>
                  <div class="kt-wizard-v1__nav-label">Map Header</div>
                </div>
              </a>
              <a
                class="kt-wizard-v1__nav-item"
                href="javascript:"
                :class="currentStep === 3 ? 'current-step' : ''"
                data-cy="importLeadsButton"
            >
              <div class="kt-wizard-v1__nav-body">
                <div class="kt-wizard-v1__nav-icon">
                  <i class="fa fa-check"></i>
                </div>
                <div class="kt-wizard-v1__nav-label">Process</div>
              </div>
            </a>
            </div>
          </div>
        </div>

        <div class="kt-grid__item kt-grid__item--fluid kt-wizard-v1__wrapper">
            <div
              class="kt-wizard-v1__content step-content"
              :class="currentStep === 1 ? 'current-step' : ''"
              style="width:100%"
            >
              <div class="row">
                  <div class="col-lg-12">
                    <v-file-input
                        placeholder="Users Master List"
                        v-model="file"
                        label="Choose File"
                        v-validate="'required'"
                        name="file"
                    ></v-file-input>
                    <span
                        class="kt-font-danger validate-error"
                        v-show="errors.has('file')"
                    >{{ errors.first('file') }}</span
                    >
                  </div>
                  <div class="col-lg-12">
                    <p>For sample template please <v-btn @click="getTemplate" x-small>click here</v-btn></p>
                    <p>
                      Please be advised that the column role can only have one of the following values: Tech, Advisor, Manager.
                    </p>
                  </div>
              </div>
            </div>
          <div
            class="kt-wizard-v1__content step-content"
            :class="currentStep === 2 ? 'current-step' : ''"
            style="width:100%"
          >
            <div class="row">
              <div class="col-lg-4">
                <v-switch label="Is Full Name" v-model="form.headers.is_full_name">
                </v-switch>
              </div>
              <div class="col-lg-4">
                <v-select
                    :label="!form.headers.is_full_name ? 'Name' : 'First Name'"
                    :items="form.mappedHeaders"
                    item-text="name"
                    v-model="form.headers.first_name"
                >
                </v-select>
              </div>
              <div class="col-lg-4" v-if="form.headers.is_full_name">
                <v-select
                    label="Last Name"
                    :items="form.mappedHeaders"
                    item-text="name"
                    v-model="form.headers.last_name"
                >
                </v-select>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <v-select
                    label="Email"
                    :items="form.mappedHeaders"
                    item-text="name"
                    v-model="form.headers.email"
                >
                </v-select>
              </div>
              <div class="col-lg-6">
                <v-select
                    label="Job Title"
                    :items="form.mappedHeaders"
                    item-text="name"
                    v-model="form.headers.job_title"
                >
                </v-select>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <v-select
                    label="Phone Number"
                    :items="form.mappedHeaders"
                    item-text="name"
                    v-model="form.headers.phone_number"
                >
                </v-select>
              </div>
              <div class="col-lg-6">
                <v-select
                    label="Dealership"
                    :items="form.mappedHeaders"
                    item-text="name"
                    v-model="form.headers.specificDealer"
                >
                </v-select>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <v-select
                    label="Role"
                    :items="form.mappedHeaders"
                    item-text="name"
                    v-model="form.headers.role"
                >
                </v-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-card-actions>
        <v-spacer>
          <v-btn depressed @click="prevStep">{{  currentStep > 1 ? 'Back' : 'Close' }}</v-btn>
          <v-btn depressed color="#f9b418" @click="nextStep">
            {{ currentStep < 3 ? 'Next' : 'Done' }}
          </v-btn>
        </v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  isEmpty as _isEmpty
} from 'lodash-es';

export default {
  name: 'ImportDealerFile',
  computed: {
    showDialog: {
      get() {
        return this.$store.state.importDealerUsers.showUploadDialog;
      },
      set(value) {
        this.currentStep = 1;
        this.$store.dispatch('importDealerUsers/setUploadDialogState', value);
      },
    },
  },
  data() {
    return {
      /**
       * name, email, job_title, role, company, dealer, phone_number
       */
      currentStep: 1,
      file: [],
      form: {
        filePath: '',
        mappedHeaders: [],
        headers: {
          email: '',
          first_name: '',
          last_name: '',
          is_full_name: false,
          dealer: '',
          specificDealer: '',
          job_title: '',
          phone_number: '',
          role: '',
        },
      },
      isEmpty: _isEmpty,
    };
  },
  methods: {
    getTemplate() {
      this.$http.get('import/template')
        .then(({ data }) => {
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'template.csv');
          document.body.appendChild(link);
          link.click();
        });
    },
    prevStep() {
      if (this.currentStep === 1) {
        this.$nextTick(() => {
          this.showDialog = false;
        });
        return;
      }
      this.$nextTick(() => {
        this.currentStep -= 1;
      });
      return;
    },
    uploadFile() {
      this.$validator.validate('file')
        .then((result) => {
          if (result) {
            const form = new FormData();
            form.append('users', this.file);
            this.$http.post('import/users', form)
              .then(({ data }) => {
                this.form.filePath = data.path;
                this.form.mappedHeaders = data.headers;
                this.$nextTick(() => {
                  this.currentStep += 1;
                });
              });
          }
        });
      // eslint-disable-next-line no-undef
    },
    nextStep() {
      if (this.currentStep === 1) {
        this.uploadFile();
        return;
      }
      if (this.currentStep === 3) {
        this.$notify('success', 'Please wait for a few minutes while we process the uploaded file.');
        this.processRows();
        this.showDialog = false;
        
        return;
      }
      this.$nextTick(() => {
        this.currentStep += 1;
      });
    },
    processRows() {
      this.$http.patch('import/users/process', {
        filePath: this.form.filePath,
        mappedHeaders: this.form.headers,
      })
         .then(({ data }) => {
           console.log(data);
         });
    },
  },
};
</script>

<style scoped lang="stylus">
#closeButton
  top 15px
  right 20px
  position absolute
  cursor pointer
  font-size 20px
  color grey
</style>